var _rect, _path, _filter, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitopsDemoPreview2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#0D1117"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#grad)",
    d: "M0 0 L800 0 L800 400 L0 400 Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0d1117",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1f2937",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "coloredBlur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fill: "#fff",
    fontFamily: "Arial",
    fontSize: 40,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "Modern DevOps Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 115,
    fill: "#8B949E",
    fontFamily: "Arial",
    fontSize: 20,
    textAnchor: "middle"
  }, "Continuous Deployment with GitOps")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 200) scale(0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "#F05133"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M-15,-15 L15,15 M-15,15 L15,-15"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "#EE7600"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    d: "M-20,-5 Q0,-25 20,-5 Q0,15 -20,-5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M-30,20 L-10,-20 L30,20 L-30,20 M0,-10 L20,15 L40,-15 L0,-10",
    filter: "url(#glow)",
    transform: "translate(450, 200)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "none",
    stroke: "#326CE5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#326CE5",
    strokeWidth: 4,
    d: "M0,-35 L30,17.5 L-30,17.5 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(750, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 35,
    fill: "#F46800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    d: "M-15,-15 Q0,-5 15,-15 M-20,0 Q0,10 20,0 M-15,15 Q0,25 15,15"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#4A5568",
    strokeDasharray: "5 5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190,200 L260,200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,200 L415,200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,200 L565,200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635,200 L715,200"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#8B949E",
    fontFamily: "Arial",
    fontSize: 14,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 260
  }, "Git"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 260
  }, "Argo CD"), /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 260
  }, "Azure"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 260
  }, "Kubernetes"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 260
  }, "Grafana"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4A5568",
    strokeWidth: 2,
    d: "M100,300 Q400,320 700,300"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#4A5568"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 300,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 310,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 300,
    r: 3
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 350,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 50,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 350,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitopsDemoPreview2);
export default __webpack_public_path__ + "static/media/gitops_demo_preview_2.a404e0c3fc890f9c41d17f43190da752.svg";
export { ForwardRef as ReactComponent };